<template>
  <div :key="src" class="absolute-fill">

    <!-- This is used as an indicator for both loading and image templates -->
    <div
      v-if="loading || (!isPreview && blob.template && !blob.user_id && isEditable && !isSelected)"
      class="absolute-fill template-editable"
    />

    <picture draggable="false" class="user-select-none">
      <img
        v-if="static && blob.img.src_static"
        draggable="false"
        :src="blob.img.src_static"
        @load="end" @error="end" @abort="end"
      >
      <template v-else>
        <!-- Note: this doesn't allow for fallbacks in case the target image didn't load, in that case we'll see the browser's broken image icon. So make sure 'try_webp' is set correctly! -->
        <source v-if="isPreview && webp && supportsWebp" :srcset="src + '.webp'" type="image/webp">
        <img :src="src" draggable="false" @load="end" @error="end" @abort="end">
      </template>
    </picture>
  </div>
</template>

<style scoped>
img {
  width: 100%;
  height: 100%;
  pointer-events: none;
  touch-action: none;
}
.template-editable {
  box-sizing: border-box;
  border: 1px dashed rgb(25, 118, 210);
  transition: background-color .2s;
}
.template-editable:hover {
  background-color: rgb(25, 118, 210, .08);
}
</style>

<script>
// If you want to experiment with slow image loading, just prefix the 'src' URL with this:
// 'http://www.deelay.me/1000/'

export default {
  name: 'image-blob',

  props: [ 'blob', 'isEditable', 'isPreview', 'isSelected', 'static' ],

  data() {
    return {
      src: null,
      webp: false,
      loading: true,
      isDragging: false
    };
  },

  created() {
    // We need to check specifically for iOS because although it supports webp, it does NOT support transparency
    // correctly in webp (if this gets fixed in the future, you can ammend the '\d\d' part of this regex)
    const iOS14AppleWebKit = /(iPad|iPhone|iPod)\s+OS\s+\d\d_.*AppleWebKit/.test(navigator.userAgent);
    this.supportsWebp = !iOS14AppleWebKit;
  },

  methods: {
    end() {
      this.loading = false;
      this.$emit('loaded');
    }
  },

  watch: {
    'blob.img': {
      immediate: true,
      deep: true,
      handler(v) {
        this.src = v.src;
        this.webp = v.try_webp;
      }
    }
  }
}
</script>
